var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import merge from 'deepmerge';
import configureTooltip from '../tooltip/main';

var buildTreemapConfiguration = function buildTreemapConfiguration(treemapConfig, seriesConfig, seriesDataObj, customConfig) {
    var dataValue = {};
    var data = [];
    var seriesType = 'treemap';
    var ValueFormat = treemapConfig.ValueFormat;
    var CurrencySymbol = treemapConfig.CurrencySymbol;
    var fieldName = treemapConfig.FieldName;
    var fieldValue = treemapConfig.ValueFieldName;
    var tooltipConfigs = seriesConfig.Tooltip.TooltipConfigs;
    var tooltipConfigLength = tooltipConfigs.length;
    var showLabels = seriesConfig.ShowLabels;
    var NAME = 'name';
    var VALUE = 'value';
    var COLOR_VALUE = 'colorValue';

    seriesDataObj && seriesDataObj.forEach(function (dataElement) {
        dataValue = {};
        dataValue[NAME] = dataElement[fieldName];
        dataValue[VALUE] = dataElement[fieldValue];
        dataValue['counter'] = dataElement['RecordCount'];
        dataValue[COLOR_VALUE] = dataElement[fieldValue] / 1000;
        if (tooltipConfigs !== null && tooltipConfigLength > 0) {

            for (var index = 0; index < tooltipConfigLength; index++) {
                dataValue[tooltipConfigs[index].Id] = dataElement[tooltipConfigs[index].Id];
            }
        }
        data.push(dataValue);
    });

    return merge({
        data: data,
        type: seriesType,
        dataLabels: {
            enabled: showLabels
        },
        layoutAlgorithm: 'squarified',
        tooltip: configureTooltip(seriesType, _extends({}, seriesConfig, { ValueFormat: ValueFormat, CurrencySymbol: CurrencySymbol }))

    }, customConfig);
};

export default buildTreemapConfiguration;